export const Messages = {
  UPLOAD_SUCCESS: "We're adding xls file data, which may take few minutes to upload.",
  NO_FILE: 'No file selected',
  ERR_ORDER_NOT_FOUND: 'Order not found',
  ERR_NO_MATERIALS: 'There are no materials',
  SOMETHING_WENT_WRONG_WHILE_UPLOAD: 'Something went wrong. Please make sure you are uploading the right set of indents.',
};

export { Messages as default };
